import { Injectable } from '@angular/core';
import { MatPaginatorIntl } from '@angular/material/paginator';

/** Czech labels for every `mat-paginator` in the app; `MatPaginatorIntl` ships English only. */
@Injectable()
export class CzechPaginatorIntl extends MatPaginatorIntl {
  override itemsPerPageLabel = 'Položek na stránku:';
  override nextPageLabel = 'Další stránka';
  override previousPageLabel = 'Předchozí stránka';
  override firstPageLabel = 'První stránka';
  override lastPageLabel = 'Poslední stránka';

  override getRangeLabel = (page: number, pageSize: number, length: number): string => {
    if (length === 0 || pageSize === 0) return `0 z ${length}`;
    const start = page * pageSize + 1;
    const end = Math.min(start + pageSize - 1, length);
    return `${start}–${end} z ${length}`;
  };
}
